import encryptServer from '@/request/encryptRequest.js';

const CATEGORY_BASE = '/xiaozi-xms/wireless/saas/goods/attributeCategory/tenant';
const ATTRIBUTE_BASE = '/xiaozi-xms/wireless/saas/goods/attribute/tenant';

// ==================== 属性分类 ====================

// 查询属性分类树（平台分类 + 我的分类）
export const getAttributeCategoryTree = data => encryptServer.post(`${CATEGORY_BASE}/tree`, data);

// 新增租户属性分类
export const addAttributeCategory = data => encryptServer.post(`${CATEGORY_BASE}/add`, data);

// 更新租户属性分类
export const updateAttributeCategory = data => encryptServer.post(`${CATEGORY_BASE}/update`, data);

// 删除租户属性分类
export const deleteAttributeCategory = data => encryptServer.post(`${CATEGORY_BASE}/delete`, data);

// 启用或禁用租户属性分类
export const enableOrDisableAttributeCategory = data => encryptServer.post(`${CATEGORY_BASE}/enableOrDisable`, data);

// 租户对平台属性分类启用或禁用
export const platformEnableOrDisableAttributeCategory = data => encryptServer.post(`${CATEGORY_BASE}/platform/enableOrDisable`, data);

// ==================== 属性 ====================

// 分页查询属性列表
export const getAttributePageList = data => encryptServer.post(`${ATTRIBUTE_BASE}/pageList`, data);

// 获取属性详情
export const getAttributeDetail = data => encryptServer.post(`${ATTRIBUTE_BASE}/detail`, data);

// 新增租户属性
export const addAttribute = data => encryptServer.post(`${ATTRIBUTE_BASE}/add`, data);

// 更新租户属性
export const updateAttribute = data => encryptServer.post(`${ATTRIBUTE_BASE}/update`, data);

// 删除租户属性
export const deleteAttribute = data => encryptServer.post(`${ATTRIBUTE_BASE}/delete`, data);

// 启用或禁用租户属性
export const enableOrDisableAttribute = data => encryptServer.post(`${ATTRIBUTE_BASE}/enableOrDisable`, data);

// 租户对平台属性启用或禁用
export const platformEnableOrDisableAttribute = data => encryptServer.post(`${ATTRIBUTE_BASE}/platform/enableOrDisable`, data);

// 回收站分页查询
export const getRecycleBinPageList = data => encryptServer.post(`${ATTRIBUTE_BASE}/recycleBin/pageList`, data);

// 还原已删除的属性
export const restoreAttribute = data => encryptServer.post(`${ATTRIBUTE_BASE}/recycleBin/restore`, data);
